import MainLayout from "@/components/layout/MainLayout.vue";
import moment from 'moment';
import axios from "axios";
import { mapGetters } from "vuex";
import { fetchNotificationCount } from "@/services/common/notification-service";
// import $ from "jquery";

export default {
    name: "courseRequestDetail",

    components: {
        MainLayout
    },

    data() {
        return {
            // course_request_detail: {
            //     course_request_id: "",
            //     course_request_title: "",
            //     course_request_details: "",
            // },
            courseRequestList: {},
            course_requests:{
                course_request_id: "",
                course_request_title: "",
                course_request_details: "",
            }
        };
    },

    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    methods: {
        getAllCourseRequest() {
            // axios.get("/course/getallcourserequestlist")
            axios.get("/course/request/all")
                .then((response) => {
                    this.courseRequestList = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Course Request API Error", error);
                });
        },
        
        getCourseRequestDetail() {
            // axios.get("/course/courseRequestDetail/" + this.$route.params.id)
            axios.get("/course/request/" + this.$route.params.id)
                .then((response) => {
                    this.course_requests = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("CourseRequest Detail API Error", error);
                });
        },

        // commentBoxSlide() {
        //     $("textarea").focus(function() {
        //         $("textarea").css("height", "100px");
        //         $("textarea").css("transition", ".5s");
        //     });

        //     $("textarea").focusout(function() {
        //         $("textarea").css("height", "45px");
        //     });
        // }
    },

    filters: {
        setMoment: function (date) {
            return moment(date).format("DD MMMM YYYY");
        }
    },

    mounted() {
        this.getAllCourseRequest();
        this.getCourseRequestDetail();
        fetchNotificationCount();
        // this.commentBoxSlide();
    }
};
